import * as ActionTypes from './actionTypes';

export const clearInfo = () => ({
  'type': ActionTypes.CLEAR_INFO,
});

export const changeListPage = (value) => ({
  'type': ActionTypes.CHANGE_LIST_PAGE,
  'payload': value,
});

export const changeListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_LIST_PAGE_SIZE,
  'payload': value,
});
